import React, {
    useState,
    useCallback,
    useImperativeHandle,
    forwardRef,
} from "react";
import debounce from "src/utils/debounce";
import styles from "./styles.module.scss";

const CustomRangeFilter = forwardRef((props, ref) => {
    const [range, setRange] = useState({
        filter: null,
        filterTo: null,
    });

    // Debounced function to trigger the filter change callback
    const onRangeChangeDebounced = useCallback(
        debounce(async (newRange) => {
            props.filterChangedCallback();
        }, 500),
        []
    );

    const onRangeChange = (event) => {
        const {
            value,
            dataset: { field },
        } = event.target;
        const newRange = {
            ...range,
            [field]: value ? parseFloat(value) : null,
        };
        setRange(newRange);
        onRangeChangeDebounced(newRange);
    };

    useImperativeHandle(ref, () => ({
        getModel() {
            if (range.filter && !range.filterTo) {
                return {
                    filter: range.filter,
                    filterTo: range.filterTo,
                    filterType: "number",
                    type: "greaterThanOrEqual",
                };
            } else if (!range.filter && range.filterTo) {
                return {
                    filter: range.filterTo,
                    filterTo: range.filter,
                    filterType: "number",
                    type: "lessThanOrEqual",
                };
            } else if (range.filter && range.filterTo) {
                return {
                    filter: range.filter,
                    filterTo: range.filterTo,
                    filterType: "number",
                    type: "inRange",
                };
            } else {
                return null;
            }
        },

        setModel(model) {
            setRange({
                filter: model ? model.filter : null,
                filterTo: model ? model.filterTo : null,
            });
        },

        doesFilterPass(params) {
            const { filter, filterTo } = range;
            const value = params.data[props.colDef.field];
            return (
                (filter === null || value >= filter) &&
                (filterTo === null || value <= filterTo)
            );
        },
        // this method indicates if the filter is active hence shows AGgrid filter icon
        isFilterActive() {
            return range.filter !== null || range.filterTo !== null;
        },
    }));

    const clearFilter = () => {
        setRange({
            filter: null,
            filterTo: null,
        });
        onRangeChangeDebounced();
    };

    return (
        <div className={styles.customRangeFilter}>
            <input
                type="number"
                data-field="filter"
                value={range.filter || ""}
                onChange={onRangeChange}
                placeholder="Min"
            />
            <input
                type="number"
                data-field="filterTo"
                value={range.filterTo || ""}
                onChange={onRangeChange}
                placeholder="Max"
            />
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    cursor: "pointer",
                }}
            >
                <button
                    onClick={clearFilter}
                    data-testid="clear-custom-range-filter"
                    style={{
                        cursor: "pointer",
                    }}
                >
                    Clear
                </button>
            </div>
        </div>
    );
});

export default CustomRangeFilter;
